import * as React from "react";

interface IProps{
    name:string;
    header:string;
    isActive?:boolean;    
}

export class Tab extends React.Component<IProps, {}>{
    constructor(props){
        super(props);
        props = Object.assign({isActive:false}, props);
                
    }     
    render() {
        return (
            <div>
                {this.props.children}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/client/assets/Tab/Tab.tsx